import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import AccountPageSettingList from './components/AccountPageSettingList';

const { Cell } = ResponsiveGrid;

const AccountPageSetting = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="帳號頁面設定"
        breadcrumbs={[
          {
            name: '帳號管理',
          },
          {
            name: '帳號頁面設定',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <AccountPageSettingList />
    </Cell>
  </ResponsiveGrid>
);

export default AccountPageSetting;
